import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";

import * as firebase from "firebase/app";
import "firebase/firestore";
import ReportSpam from "../models/report-spam.model";
import { environment } from "../../environments/environment";
import { NotificationService } from "./notifications.service";

@Injectable({
  providedIn: "root",
})
export class ReportSpamService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/report-spams";

  collRef: AngularFirestoreCollection<ReportSpam>;

  constructor(
    private db: AngularFirestore,
    private userStore: UserService,
    private notiService: NotificationService
  ) {
    this.collRef = db.collection(this.dbPath);

    this.userStore.getCurrentUser().subscribe((user: User) => {
      this.userLogin = user;
    });
  }

  getReports(limit?: number, cursor?: any): any {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("isConfirmed", "==", false)
      .orderBy("updatedOn", "desc");

    ref = limit ? ref.limit(limit) : ref.limit(10);

    if (cursor) {
      ref = ref.startAfter(cursor);
    }

    return ref.get();
  }

  getMyReports(uid: string, limit?: number, cursor?: any): any {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("isConfirmed", "==", false)
      .where("createdBy", "==", uid)
      .orderBy("updatedOn", "desc");

    ref = limit ? ref.limit(limit) : ref.limit(10);

    if (cursor) {
      ref = ref.startAfter(cursor);
    }

    return ref.get();
  }

  get(id: string) {
    return this.collRef.doc(id).valueChanges();
  }

  getById(id: string) {
    var db = firebase.default.firestore();
    var ref = db.collection(this.dbPath).doc(id);

    return ref.get();
  }

  create(reported: ReportSpam): any {
    reported.refAuthor = reported.refAuthor ? reported.refAuthor : null;
    reported.isConfirmed = false;
    reported.isActive = true;
    reported.isDeleted = false;
    reported.createdOn = new Date();
    reported.createdBy = this.userLogin.uid;
    reported.updatedOn = new Date();
    reported.updatedBy = this.userLogin.uid;
    reported.author = this.userLogin;
    reported.visibility = this.visibility;

    return this.collRef.add({ ...reported }).then((docRef) => {
      reported.id = docRef.id;

      if (reported.refUid != this.userLogin.uid) {
        this.notiService.create(
          "Báo xấu",
          reported.mode,
          reported.refId,
          reported.id,
          reported.refTitle,
          reported.refDescription,
          reported.refUid,
          reported.refUrl,
          reported.courseId
        );
      }

      return reported;
    });
  }

  confirm(reported: ReportSpam): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    return this.collRef.doc(reported.id).update({
      isConfirmed: reported.isConfirmed,
      confirmedOn: updatedOn,
      confirmedBy: updatedBy,
      confirmedAuthor: this.userLogin,
      isTrusted: reported.isTrusted,
      isActive: reported.isActive,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
    });
  }
}
